import { recordResponseSerializer } from "@api/utils";

const OrderSerializers = {
  responseSerializer: function (hit) {
    // This line is needed to get the resolved fields
    // to be able to display them later in the form
    hit.metadata.order_lines = hit.metadata.resolved_order_lines;

    const serializedHit = recordResponseSerializer(hit);

    // If backend didn't calculate total_cost, calculate it in frontend
    if (
      !serializedHit.metadata.total_cost &&
      serializedHit.metadata.cost &&
      serializedHit.metadata.copies_received
    ) {
      serializedHit.metadata.total_cost =
        Math.round(
          serializedHit.metadata.cost *
            serializedHit.metadata.copies_received *
            100
        ) / 100;
    }

    return serializedHit;
  },
};

export const orderSerializer = {
  fromJSON: OrderSerializers.responseSerializer,
};
